const blogPosts = [
  {
    id: 1,
    title: "How to Make Your First Beat",
    image: "/images/blog 1.jpeg",
    excerpt: "Learn the basics of beat making, from picking your DAW to arranging your first track.",
    content: `
      Making your first beat is exciting! 
      1. Choose a Digital Audio Workstation (DAW) like FL Studio, Ableton, or Logic Pro.
      2. Start with a simple drum loop to set the rhythm.
      3. Add melodies using virtual instruments or samples.
      4. Arrange your track into intro, verse, and chorus sections.
      5. Export and share your beat with friends or potential buyers.
    `,
  },
  {
    id: 2,
    title: "Adding Your Bank Account for Payouts",
    image: "/images/blog.webp",
    excerpt: "Step-by-step guide on adding and verifying your bank account to receive earnings from your beats.",
    content: `
      To receive payments:
      1. Go to your dashboard.
      2. Navigate to 'Payout Settings'.
      3. Add your bank account details (Account Number, Bank Name, Swift Code if needed).
      4. Verify your account via email or SMS.
      5. Once verified, you’ll be able to withdraw your earnings directly.
    `,
  },
  {
    id: 3,
    title: "Promoting Your Beats Online",
    image: "/images/blog5.jpg",
    excerpt: "Discover marketing strategies to reach more listeners and increase your beat sales.",
    content: `
      To promote your beats effectively:
      1. Share snippets on Instagram, TikTok, and YouTube.
      2. Collaborate with upcoming artists.
      3. Use hashtags related to your genre.
      4. Run targeted ads on Facebook and Instagram.
      5. Consistently release new beats to keep your audience engaged.
    `,
  },
  {
    id: 4,
    title: "Selling Exclusive vs Non-Exclusive Beats",
    image: "/images/blog.webp",
    excerpt: "Understand the differences between exclusive and non-exclusive licensing to price your beats right.",
    content: `
      Exclusive Beats:
      - Sold to one buyer only.
      - Buyer gets full rights to the beat.
      - Usually sold at a higher price.
      
      Non-Exclusive Beats:
      - Can be sold to multiple buyers.
      - You keep the rights to resell.
      - More affordable for artists but less unique.
    `,
  },
  {
    id: 5,
    title: "Protecting Your Beats from Theft",
    image: "/images/blog5.jpg",
    excerpt: "Tips on watermarking and registering your beats to protect your intellectual property.",
    content: `
      Protect your beats by:
      1. Adding a voice tag or watermark.
      2. Registering with a copyright office.
      3. Keeping timestamps of creation.
      4. Only sending high-quality untagged versions after purchase.
    `,
  },
];

export default blogPosts;
